module.exports = __webpack_public_path__ + "static/img/zj-sh3.fa9a9a22.png";